import { AxiosError } from 'axios';
import api from '../../../services/cle';
import { useState, useEffect } from 'react';
import { useAppSelector } from '../../../store/hooks';
import { tratarErroApi } from '../../../rxlib/services/utilitarios';
import { Listagem } from '../../../rxlib/components/layout/listagem';
import { usuarioTemPermissao } from '../../../rxlib/services/seguranca';
import AcessoBloqueado from '../../../rxlib/components/acesso-bloqueado';
import { ApiError, SelecaoLicencaBaseProps } from '../../../services/tipos';
import { RxlibLayout } from '../../../rxlib/components/layout/rxlib-Layout';
import { ModalWarning } from '../../../rxlib/components/modal/modal-warning';
import Breadcrumb, { BreadcrumbItem } from '../../../rxlib/components/breadcrumb';
import { AcoesTabela, ConfiguracoesTabela } from '../../../rxlib/components/table';

function SelecaoLicencaBase(props: SelecaoLicencaBaseProps) {
    const [licencasBase, setLicencasBase] = useState<[{}]>([{}]);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [messageWarning, setMessageWarning] = useState<string[]>([]);
    const [nomeOrganizacao, setNomeOrganizacao] = useState<string>('');

    const handleHide = () => setShowWarning(false);

    const breadcrumbs: BreadcrumbItem[] = [
        { texto: 'Home', link: '/home' },
        { texto: 'Organizações e unidades', link: '/organizacao' },
        { texto: 'Licenças da organização', link: `/organizacao/licenca/${props.match.params.idorganizacao}` },
        { texto: 'Seleção de licença base', link: '' },
    ];

    const configuracoesTabela: ConfiguracoesTabela = {
        mensagemPadrao: 'Não foram encontrados resultados para a consulta.',
        colunas: [
            { nome: 'Descrição', campo: 'Descricao', tipo: 'string' },
            { nome: 'Chave', campo: 'Chave', tipo: 'string' },
        ],
    }

    const temPermissao = usuarioTemPermissao(token, 'licenca_base_visualizar');

    useEffect(() => {
        if (temPermissao) {
            if (props.match.params.idorganizacao) {
                setCarregando(true);
                Promise.all([
                    api.get(`/Organizacao/${props.match.params.idorganizacao}`),
                    api.get(`/OData/LicencaBase`)
                ]).then(response => {
                    setTimeout(() => {
                        setNomeOrganizacao(response[0].data.nome);
                        setLicencasBase(response[1].data.value);
                        setCarregando(false);
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregando(false);
                    setMessageWarning(tratarErroApi(error, 'Não foi possível realizar a consulta: '));
                    setShowWarning(true);
                });
            }
        }
    }, [props.match.params.idorganizacao, temPermissao]);

    function obterAcoesPersonalizadas(): AcoesTabela[] {
        const acoesPersonalizadas: AcoesTabela[] = [];

        if (usuarioTemPermissao(token, 'licenca_organizacao_historico')) {
            acoesPersonalizadas.push({ link: `/organizacao/licenca/${props.match.params.idorganizacao}/novo`, nome: 'Selecionar', iconeClassName: 'fas fa-hand-pointer me-3' });
        }

        return acoesPersonalizadas;
    }

    return (
        <>
            <RxlibLayout>
                <Breadcrumb
                    itens={breadcrumbs} />
                <Listagem
                    campoId='Id'
                    tipoBotaoAcao='button'
                    listagemDetalhe={false}
                    carregando={carregando}
                    fonteDados={licencasBase}
                    configuracoesTabela={configuracoesTabela}
                    acoesPersonalizadas={obterAcoesPersonalizadas()}
                    descricao={`Seleção de licenças base para a organização: ${nomeOrganizacao}`} />
                <ModalWarning
                    show={showWarning}
                    onHide={handleHide}
                    message={messageWarning} />
                <AcessoBloqueado
                    permissao={temPermissao} />
            </RxlibLayout>
        </>
    );
}

export default SelecaoLicencaBase;